import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Location, PopStateEvent } from "@angular/common";
import { ShopService } from './shop.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private shop: ShopService, private router: Router, private location: Location) { }
  ngOnInit() {
    // if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
    //   let cartID = window.localStorage.getItem('cartID');
    //   if (cartID) {
    //     this.shop.setCheckout(cartID);
    //   } else {
    //     this.shop.createCheckout();
    //   }
    // }

    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((ev: any) => {
        if (ev instanceof NavigationStart) {
          if (ev.url != this.lastPoppedUrl)
            this.yScrollStack.push(window.scrollY);
        } else if (ev instanceof NavigationEnd) {
          if (ev.url == this.lastPoppedUrl) {
            this.lastPoppedUrl = undefined;
            window.scrollTo(0, this.yScrollStack.pop());
          } else
            window.scrollTo(0, 0);
        }
      });
   }

  }
}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/app.component.ts